import React, { useState, useEffect } from 'react';
import Multiselect from 'react-widgets/Multiselect';
import { POST_MEDIA_VALIDATION } from '../../../redux/constants';

const YouTubePlaylistChooser = (props) => {
    const [ selectedPlaylists, setSelectedPlaylists ] = useState([]);
    const [ playlists, setPlaylists ] = useState([]);
    const [ playlistError, setPlaylistError ] = useState('');

    useEffect(() => {
        if (Object.keys(props.socials.playlists).length) {
            let keys = Object.keys(props.socials.playlists),
                nextPlaylists = [];
            for (let i = 0; i < keys.length; ++i) {
                let key = keys[i],
                    social = props.socials.list.find(({id}) => { return id === parseInt(key); });

                if (social) {
                    let options = props.socials.playlists[key];
                    for (let j = 0; j < options.length; ++j) {
                        let option = Object.assign({socialId: key, socialName: social.name}, options[j]);
                        nextPlaylists.push(option);
                    }
                }
            }
            setPlaylists(nextPlaylists);
        }
    }, [props.socials.playlists]);

    useEffect(() => {
        let errors = props.getApiErrors(['SOCIAL_GET_PLAYLISTS']);
        if (errors.length && errors[0].errors.validation !== undefined && errors[0].errors.validation.id !== undefined) {
            setPlaylistError("Reconnect this channel to access your playlists");
            props.deleteApiError(['SOCIAL_GET_PLAYLISTS']);
        }
    });

    const changeCallback = (values) => {
        let nextPlaylists = [],
            changeEvent = {
                currentTarget: {
                    dataset: {
                        field: props.field
                    }
                },
                target: {
                    value: []
                }
            };

        for (let i = 0; i < values.length; ++i) {
            nextPlaylists.push({
                id: values[i].id,
                title: values[i].title
            });
        }

        changeEvent.target.value = nextPlaylists;

        props.onChange(changeEvent);

    }

    let emptyMessage = 'This channel has no playlists';
    if (playlists.length) {
        emptyMessage = "You've selected all playlists";
    }

    if (playlistError) {
        emptyMessage = playlistError;
    }

    return (
        <Multiselect
            data={playlists}
            defaultValue={props.playLists}
            textField={'title'}
            dataKey={'id'}
            onChange={changeCallback}
            placeholder={"Add videos to your YouTube playlists"}
            className="playlist-chooser"
            messages={{
                emptyList: emptyMessage
            }}/>
    );
};

export default YouTubePlaylistChooser;
